const features = [
  {
    id: 1,
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '支持1080P与4K超高清画质，影院级视觉享受，每一帧都纤毫毕现',
    color: 'bg-primary-500',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '极速加载',
    desc: '全球CDN加速节点覆盖，秒开不缓冲，流畅追剧零等待',
    color: 'bg-accent-500',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '安全免VIP',
    desc: '无需注册、无需付费，打开即看，无任何隐藏收费或广告弹窗',
    color: 'bg-secondary-500',
  },
  {
    id: 4,
    icon: 'ri-device-line',
    title: '全端适配',
    desc: 'PC、平板、手机全端完美适配，随时随地畅享追剧乐趣',
    color: 'bg-primary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            为什么选择成全影视
          </h2>
          <p className="text-sm text-foreground-500 mt-1">致力于打造最好的免费观影体验</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-xl p-6 md:p-7 text-center group cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 ${feature.color} rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} text-white text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}